<template>
  <div id="sub">

    <!-- 연계상품리스트(일반형) -->
    <section id="pack" class="packages">
			<div class="container">
				<div class="packages-content">
					<div class="row gx-4">
            <!-- 제목 -->
            <div class="sub-title" id="world-etc">
              <div  v-if="assoFlag != ''">
                <div v-if="assoFlag === 'lj'" class="assoText">
                  <!-- <img :src="getImageUrl(assoFlag)" class="assoLogo"> -->
                  <img src="../assets/img/asso/jin.png" class="assoLogo_jin">
                  <span class="text-content">&nbsp;와&nbsp;&nbsp;함께하는&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  <img src="../assets/img/asso/nd.png" class="assoLogo_nd">
                  <span class="text-content">&nbsp;추천 일본 버스투어 특가!</span>
                </div>
                <div v-else>
                  <img :src="getImageUrl(assoFlag)" class="assoLogo" style="width: 70%;">
                </div>
              </div>
            </div>
            
            <!-- 내용 -->
						<div class="col-lg-4 col-md-6 col-sm-12 mb-5 mt-5" :key="j" v-for="(nd, j) in this.productListForSales">
              
              <div class="text-decoration-none link-dark">
                <div class="package-item grImg">
                  <div class="pic" @click='goToDetail(nd.pdtCode,nd.salesRoute,nd.assoFlag)' style="cursor: pointer">  
                    <div class="packages-hover">
                      <div class="packages-hover-content"></div>
                    </div>
                    <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="card-img-top pdImg" alt="..."/>
                    <img v-else :src="`/download/noImage/noImage.jpg`" class="card-img-top pdImg"/>
                    <div class="badge">
                      <div v-if="nd.badgeFlag === 'Y'">
                        <div class="badge1">
                          <small class="badge1-text">{{ nd.badge }}</small>
                        </div>
                      </div>
                      <div v-else></div>
                    </div>
                    </div>
                  <div class="package-item-txt">
                    <div class="pdtName">
                      {{ nd.pdtNameKor }}
                    </div>
                    <div class="pdtRemarks">
                        <i class="bi bi-bus-front-fill"></i> {{ nd.pdtRemarks }}
                    </div>
                    <hr>
                    <div class="price">
                      <div class="mt-0 priceSection">
                        <div>
                          <!-- 상품가격표시 -->
                          <div v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'" @click="goToDetail(nd.pdtCode, nd.salesRoute)" style="cursor: pointer">
                            <span class="text-muted text-decoration-line-through mx-2 ndayPrice" style="font-weight: 600; font-size: 1.1rem;"> {{ getCurrencyFormat(nd.pdtPrice) }} 원</span>
                            <i class="bi bi-caret-right-fill"></i>
                              <!-- <span class="mx-2 ndayPrice text-danger fw-bolder" style="padding-left: 8px; font-size: 1.3rem;"> {{ getCurrencyFormat(nd.discountPercent) }}%</span> -->
                              <span class="ndayPrice fw-bolder" style="font-size: 1.5rem; color: red; padding-left: 10px;">{{ getCurrencyFormat(((nd.basic_PdtPrice*1) + (nd.minOptPrice*1)) - (((nd.basic_PdtPrice*1) + (nd.minOptPrice*1))*(nd.asso_DCRate))/100) }}</span><span cass="fs-5"> 원~</span>
                          </div>
                          <div style="display:flex;" v-else>
                            <span class="ndayPrice fw-bold" style="font-size: 1.2rem;">상품을 준비 중입니다</span> 
                            <i class="bi bi-question-circle-fill text-danger" style="cursor: pointer; padding-left: 5px; font-size: 1.0rem;" data-bs-toggle="tooltip" ta-bs-placement="top" title="해당상품에 대한 문의가 필요하신 경우 클릭해주세요"  @click="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

						</div>
					</div>
				</div>
			</div>

      <!-- 배너 -->
      <div class="banner2 d-flex justify-content-center">
        <!-- <a href="/membershipPage" onclick="window.open('/membershipPage', '_blank', 'top=100')"> -->
        <a href="/membershipPage" target="_blank"> 
          <img src="../assets/img/new-test/banner3.jpg" class="img-fluid pc">
          <img src="../assets/img/new-test/banner3-2.jpg" class="img-fluid pad">
          <img src="../assets/img/new-test/banner3-3.jpg" class="img-fluid mobile">
        </a>
      </div>
    </section>
    
  </div>
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      ntToAr: {},                   //버스투어가능국가지역
      ntToAr_jp: [],                //일본내 버스투어가능지역
      ntToAr_etc: [],               //버스투어가능 국가와 지역
      nt: "",                       //상품카테고리(국가기준)
      ar: "",                       //상품카테고리(지역기준)

      sellerCode: "ND",             //판매자코드

      productListForSales_org: [],  //로컬전체상품
      productListForSales: [],      //판매상품리스트
      etc_more: "N",                //일본외 더보기

      //showLayer: false,           //지역(국가)선택레이어

      natName: "",                      //표시페이지 국가명
      selectableNation: [],             //선택가능 국가

      nationList: {},                   //여행지역리스트
      pdtCatList: {},                   //상품카테고리
      
      productListForSales_recomend: {}, //추천상품리스트
      // pPriceY: 0,
      // pPriceN: 0,
      // pPriceE: 0,
      
      // dispPrice: [],        //가격표시방법(mem / promo)

      // promoPrice: 0,        //프로모션할인액
    };
  },
  created() {
    // 페이지생성과 동시에 리스트정보를 get
		this.nt = (this.$route.query.nt == undefined) ? "%" : this.$route.query.nt;
    this.ar = (this.$route.query.ar == undefined) ? "%" : this.$route.query.ar;
		this.sellerCode = (this.$route.query.sc === undefined) ? "ND" : this.$route.query.sc;
    this.assoFlag = this.$route.query.assoFlag
    //console.log("assoFlag: ", this.assoFlag)

    this.getProductList_new();
    //this.getProductList();
    this.getNationList();
    this.getBustourArea();
  },
  mounted() {
    if(this.assoFlag == "") {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'warning').then(() => {
        location.replace("https://ntabi.co.kr");
      })
    }

    //상세정보와 무관한 내용 비표시처리
    document.getElementById("user").style.display = "none";
    document.getElementById("userM").style.display = "none";
    ////document.getElementById("notice").style.display = "none";

    //페이지뷰 카운팅
    this.countPageView(this.assoFlag, this.assoFlag)
  },
  computed: {
    user() {
      // 리턴정보가 바뀔 때마다 user()안에 넣어준다
      // 로그인전: bId정보없음, 로그인후: bId정보있음
      return this.$store.state.user;
    }
  },  
  methods: {
    async countPageView(pdtCode, fAssoFlag){
      let vParam = "V"
      let countPageView = await this.$api("/api/proc_countPageView", {param:[ pdtCode, fAssoFlag, vParam ]})
      if(countPageView.affectedRows > 0)
      {
        console.log("We appreciate for your visiting!")
      }
    },

    getImageUrl(flag) {
      try 
      {
        // require를 사용하여 동적으로 이미지 로드
        return require(`@/assets/img/asso/${flag}.png`);
      } 
      catch (error) 
      {
        console.error("이미지를 찾을 수 없습니다:", error);
        return ''; // 이미지가 없을 경우 대체 이미지 경로 또는 빈 문자열 반환
      }
    },

    async getNationList() 
    {
      let nationList = await this.$api("/api/nationList", {});
      this.nationList = nationList;
      
      let natName = nationList.filter((item) => {
        return item.baseCode == this.nt
      })
      this.natName = natName.codeNameKor
      //console.log("nationList:",this.nationList,",natName:",this.natName)
    },

    //선택가능한 버스투어 지역정보
    async getBustourArea() {
      let bustourArea = await this.$api("/api/getBustourArea_asso", {param:[this.assoFlag]})

      //console.log("bustourArea:", bustourArea)

      let ntToAr = {}

      if(bustourArea.length > 0)
      {
        this.bustourArea = bustourArea
        //국가별 지역으로 정리
        bustourArea.forEach(item => {
          if(!ntToAr[item.ntCd])
          {
            ntToAr[item.ntCd] = [];
          }
          ntToAr[item.ntCd].push({
            ntCd: item.ntCd,
            arCd: item.arCd,
            NT: item.NT,
            AR: item.AR
          })
        })
      }
      this.ntToAr = ntToAr
    },


    // mixins에 있는 공통함수 호출샘플
    /** 자릿수 표시 */
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    /** 개행처리 */
    getStringFormat(text) {
      return this.$stringFormat(text);
    },
		/** 일자처리 */
    getDateFormat(date)
    {
      return this.$dateFormat(date);
    },

    showEtcSelArea(param) {
      if(param === 'all') 
      {
        //document.querySelector('.more-etc').style.display = 'block'
        // document.querySelector('.more-etc').classList.add('initial-state');
        this.productListForSales = this.productListForSales_org.slice(0,6)
      }
      else
      {
        //document.querySelector('.more-etc').style.display = "none"
        let productListForSales_tmp = this.productListForSales_org.filter(item => {
          return item.ntCd === param
        })

        this.productListForSales = productListForSales_tmp.slice(0,6)
      }
    },

    // //상품 더보기 처리
    // showEtcMoreList() {
    //   this.etc_more = (this.etc_more === 'Y') ? "N" : "Y"
    //   if(this.etc_more === "N")
    //   {
    //     //this.productListForSales = this.productListForSales_more
    //     this.productListForSales = this.productListForSales.slice(0,6)
    //   }
    //   else
    //   {
    //     //this.productListForSales = this.productListForSales.slice(0,6)
    //     this.productListForSales = this.productListForSales_more
    //   }
    // },

    // 신가격정책이 적용된 상품리스트
    async getProductList_new() 
    {
      // let ntCd = this.nt
      // let arCd = this.ar
      let sRoute = "L";
      // let sMinPrice = 0;
      // let sMargin = 0;

      //console.log("ntCd:",ntCd,"arCd:",arCd);

      // 전체로컬상품추출 후, 연계상품만 추출
      // let productListForSales_tmptmp = await this.$api("/api/productListForSales", {param: ['%', sRoute]});
      let productListForSales_tmptmp = await this.$api("/api/product_localtour_m", {param: [sRoute]});
      let productListForSales_tmp = productListForSales_tmptmp.filter((item) => {
        return (item.assoFlag == this.assoFlag && item.assoFlag != 'lj')
      })
      
      if(productListForSales_tmp.length > 0) 
      {
        this.productListForSales_org = productListForSales_tmp    //로컬전체상품(org)
      }
      
      // console.log("productListForSales_org: ", this.productListForSales_org)

			//엔데트립 상품만 추출
			if(this.sellerCode === 'ND')
			{
				let productListForSales_ndaytrip1 = this.productListForSales_org.filter((item) => 
				{
					return item.sellerCode_nd == "Y";
				});

        let productListForSales_ndaytrip = productListForSales_ndaytrip1.sort((a, b) => {
          if (a.ntCd == 'JP' && b.ntCd != 'JP') 
          {
            return -1;
          } 
          else if (a.ntCd != 'JP' && b.ntCd === 'JP') 
          {
            return 1;
          } 
          else if (a.ntCd < b.ntCd) 
          {
            return -1;
          } 
          else if (a.ntCd > b.ntCd) 
          {
            return 1;
          } 
          else 
          {
            return 0;
          }
        });
        
				this.productListForSales = productListForSales_ndaytrip;
			}
    },

    // 상품문의
    inquiryProduct(pCode, sRoute) {
      this.$router.push({path: '/inquiryProduct', query: {productId: pCode, salesRoute:sRoute}});
    },


    goToDetail(productId, salesRoute, assoFlag) {
      this.$router.push({path: '/productDetail_asso', query: {productId: productId, salesRoute:salesRoute, asso:assoFlag}});
    },
    // 숫자콤마표시
    // getCurrencyFormat(value) {
    //   // console.log('value' + value)
    //   return (value+"").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap');

/* @media screen and (min-width: 1000px) {
  #pack .packages {
    margin-top: -50px;
  }
} */

  #pack .sub-title .pc_display {
    display: block;
  
  }
  #pack .sub-title .mb_display {
    display: none;
  }


@media screen and (max-width: 991px) {
  #pack .sub-title .pc_display {
    display: none;
  }
  #pack .sub-title .mb_display {
    display: block;
    margin-top: -70px;
  }

}


@media screen and (max-width: 800px) {
  #pack .sub-title .pc_display {
    display: none;
  }
  #pack .sub-title .mb_display {
    display: block;
  }

  #pack .sub-title .mb_display .assoLogo_jin {
    width: 180px;
  }
  #pack .sub-title .mb_display .assoLogo_nd {
    width: 150px;
    margin-top: 15px;
  }
  #pack .sub-title .mb_display .assoMainText {
    font-size: 1.5rem;
  }
}


@media screen and (max-width: 500px) {
  #pack .sub-title .mb_display .assoLogo_jin {
    width: 150px;
  }
  #pack .sub-title .mb_display .assoLogo_nd {
    width: 120px;
    margin-top: 12px;
  }
  #pack .sub-title .mb_display .assoMainText {
    font-size: 1.2rem;
  }
}

/******************************* 
  # assoText
*******************************/
#asso_main .assoText {
  font-size: 2rem;
  display: flex;
  align-items: flex-end;
  font-weight: 800;
}

#asso_main .assoLogo_jin {
  width: 27%;
  vertical-align: bottom;
}

#asso_main .assoLogo_nd {
  width: 15%;
  vertical-align: bottom;
}

#asso_main .text-content {
  position: relative;
  bottom: -7px;
}

#asso_main div:not(.assoText) {
  display: flex;
  align-items: flex-end;
}


/***********************************
  # Product List
************************************/
.grTitle {
  font-size: 2rem;
  font-weight: 800;
  padding-left: 0px;
  padding-bottom: 3px;
}

.pCat {
  display: inline-block;
  vertical-align: top;
  padding: 8px;
  padding-bottom: 30px;
}

.grImg {
  max-width: 475px;
  width: 100%;
  border-radius: 5%;
}

.pdImg {
  border-radius: 5%;
}

.circle {
  font-size: 1rem; 
  vertical-align: middle;
  position: relative;
  top: -2px;
}


/*--------------------------------------------------------------
	# 연계상품 표시
--------------------------------------------------------------*/
.packages{
  margin: 5rem 0;
}


/* 내용 */
#sub .packages .package-item{
  -webkit-transition: .5s; 
  -moz-transition:.5s; 
  -ms-transition:.5s; 
  -o-transition:.5s;
  transition: .5s;
  height:auto;
}
@media (max-width: 991px){
	#sub .packages .package-item{
		margin-bottom:3.5rem;
	}
  #sub .packages .sub-etc{
    margin-bottom:1.5rem
  }
}

#sub .package-item .pic{
  position:relative;
}
#sub .package-item .card-img-top {
  width: 100%;
  min-height:350px;
  max-height:350px;
  object-fit: cover;
}

#sub .package-item .pic .packages-hover {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  align-items: center;
  justify-content: center;
  opacity:0;
  transition: opacity ease-in-out 0.5s;
}
#sub .package-item:hover .pic .packages-hover {
  opacity:.7;
}
#sub .package-item-txt{
  padding: 0 5px;
}
#sub .package-item h3{
  text-align:start;
  position: relative;
  font-size: 1rem;
  line-height:23px;
  color: #000;
  font-weight:600;
  padding-top: 15px;
  width: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
#sub .package-item-txt h3{
  height:60px;
}
#sub .packages-para{
  text-align:start;
  text-transform: capitalize;
	font-size: .75rem;
  color: #777;
}

/* #sub .packages-para-etc{
  text-align:center;
  text-transform: capitalize;
	font-size: .75rem;
  color: #777;
}

#sub .packages-para,.packages-para-etc p{
  margin-bottom:0;
  width: auto;
  height:20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
} */

#sub .packages-content .price {
	float:left;
  font-size: 1.2rem;
  font-weight:600;
  color:#111;
}

/* .fingerPointer {
  cursor: pointer;
} */


/*--------------------------------------------------------------
	# 연계상품 정보
--------------------------------------------------------------*/
/* #sub .sub-etc{
  margin-bottom:2rem
}
#sub .sub-etc img{
  border-radius: 15px;
}
#sub .sub-etc h3{
  text-align: center;
  -webkit-line-clamp: 1;
  height:auto
} */

#sub .sub-etc .price{
  text-align: start;
  padding-left: 1rem;
  float:none;
  font-size:1.3rem
}
#sub .sub-etc .pic .packages-hover{
  border-radius: 15px;
}


/*--------------------------------------------------------------
	#배너
--------------------------------------------------------------*/
#sub .banner2{
  background-color: #49b8f8;
  width: 100%;
  height: auto;
  margin: 1rem 0;
}
#sub .banner2 .pc{
  display: block;
}
#sub .banner2 .pad{
  display: none;
}
#sub .banner2 .mobile{
  display: none;
}
@media (max-width:699px){
  #sub .banner2{
    margin:1rem 0;
  }
  #sub .banner2 .pc{
    display: none;
  }
  #sub .banner2 .pad{
    display: none;
  }
  #sub .banner2 .mobile{
    display: block;
  }
}
@media (min-width:700px) and (max-width:1800px){
  #sub .banner2 .pc{
    display: none;
  }
  #sub .banner2 .pad{
    display: block;
  }
  #sub .banner2 .mobile{
    display: none;
  }
}

/**
  # 상품 제목 & 설명
*/
.pdtName {
  height: 3.7rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;      /* 2줄 제한 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;    /* ... 표시 */
  line-height: 1.4em;
  /* max-height: 3em; */
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 5px;
}

.pdtRemarks {
  font-size: 0.9rem;
  color: darkgray;
  padding-top: 5px;
  height: 3rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;      /* 2줄 제한 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;    /* ... 표시 */
  line-height: 1.4em;
  /* max-height: 3em; */
  margin-bottom: 1px;  
}



/* 뱃지 */
#sub .badge {
  /* width: 120px; */
  text-align: center;
}

#sub .badge .badge1{
  position: absolute;
  top:0;
  left:0;
  background-color:red;
  opacity: 0.7 !important;
  padding:15px 15px;
  width: 220px;
}
#sub .badge .badge1 .badge1-text{
  /* color:#fff; */
  color: white;
  font-size:1.2rem;
  padding:0
}

/*
#sub .badge .badge2{
  position: absolute;
  top:0;
  left:30px;
  background-color:white;
  opacity: 0.8 !important;
  padding:15px 15px;
  width: 200px;
}
#sub .badge .badge2 .badge2-text{
  color:#000;
  font-size:1.2rem;
  padding: 0;
}
*/

</style>
